// extracted by mini-css-extract-plugin
module.exports = {"root":"editor-string_root__3Vbyn"};